import React from 'react'
import { AlertContext, AlertContextProps } from './AlertContext'

export function useAlert(): AlertContextProps {
    return React.useContext(AlertContext)
}